










import { Vue, Component } from 'vue-property-decorator';
import SimSolicitudes from '@/pantallas/Conecta/SIMSolicitudes/SimSolicitudes.vue';

@Component({
  components: {
    SimSolicitudes,
  },
})
export default class SimSolicitudesPantalla extends Vue {}
